import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParentButtonComponent from './ParentButtonComponent';
import LocalizedNavLink from '../router/LocalizedNavLink';

class LinkButtonComponent extends Component {
    render() {
        const { target, id, to, title, color, cssClass, text, onClick } = this.props;
        return (
            <ParentButtonComponent
                tag={LocalizedNavLink}
                color={color}
                cssClass={cssClass}
                attr={{
                    to,
                    title,
                    target,
                    id,
                    onClick
                }}>
                {text}
            </ParentButtonComponent>
        );
    }
}

LinkButtonComponent.propTypes = {
    text: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    cssClass: PropTypes.string,
    to: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    id: PropTypes.string,
    target: PropTypes.string,
    onClick: PropTypes.func
};

export default LinkButtonComponent;



// WEBPACK FOOTER //
// ./src/components/button/LinkButtonComponent.js